import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface StateSelectorProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  required?: boolean;
  showNebraskaNote?: boolean;
}

// US States list
const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
];

const StateSelector: React.FC<StateSelectorProps> = ({ 
  value, 
  onChange, 
  className = '',
  required = false,
  showNebraskaNote = false
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor="state" className="text-white">
        State {required && <span className="text-red-400">*</span>}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-gray-800 border-gray-600 text-white">
          <SelectValue placeholder="Select your state" />
        </SelectTrigger>
        <SelectContent className="bg-gray-800 border-gray-600 max-h-60">
          {US_STATES.map((state) => (
            <SelectItem 
              key={state} 
              value={state}
              className="text-white hover:bg-gray-700"
            >
              {state}
              {state === 'Nebraska' && showNebraskaNote && (
                <span className="text-xs text-amber-400 ml-2">(19+ for NIL)</span>
              )}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showNebraskaNote && value === 'Nebraska' && (
        <p className="text-xs text-amber-400">
          Note: Nebraska law requires athletes to be 19+ for NIL agent contact.
        </p>
      )}
    </div>
  );
};

export default StateSelector;
